import { Box } from '@mui/material';
import type { FC } from 'react';
import { Spinner } from './Spinner';

const LoadingPage: FC = () => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="center"
    padding="50px"
    width="100%"
    height="100vh"
  >
    <Spinner size="30px" />
  </Box>
);

export default LoadingPage;
